import React, { MouseEvent, useState } from 'react';
import { Delete } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import InsideSaving from 'components/loading/InsideSaving';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { api } from 'services/api';
import { toast } from 'react-toastify';
import { Specialty } from 'types/specialty';

type SpecialtyItemModuleProps = {
  specialty: Specialty;
  handleSearch: () => void;
};

const SpecialtyItemModule: React.FC<SpecialtyItemModuleProps> = ({ specialty, handleSearch }) => {
  const [deleting, setDeleting] = useState(false);

  function handleDelete(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setDeleting(true);

    api
      .delete(`/specialties/${specialty.id}`)
      .then(() => {
        toast.success('Especialidade excluída com sucesso');
        handleSearch();
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Erro ao excluir especialidade');
      })
      .finally(() => setDeleting(false));
  }

  return (
    <ModuleCard
      idLabel={`ID ${specialty.id}`}
      title={specialty.name}
      subtitle="Especialidade"
      actions={
        <Tooltip title="Excluir especialidade">
          <IconButton onClick={handleDelete} color="error" size="small">
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      }
      onClick={() => history.push(`/specialties/${specialty.id}`)}
    >
      {deleting && <InsideSaving />}
    </ModuleCard>
  );
};

export default SpecialtyItemModule;
